import React from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import i18n from '~/i18n'
import DeliverabilitySplash from '~/Common-Objects/Onboarding/splashes/deliverability.png'
import { OnboardingStep } from '~/Common-Objects/Onboarding'

export default function DeliverabilityStep({ isOpen, isComplete, onClick, onOptimize, postHogTag }) {
    return (
        <OnboardingStep
            key='deliverability'
            title={i18n.t('setup:steps.optimise-deliverability.title')}
            icon={<Icons icon='envelopeTick' color='currentColor' />}
            isOpen={isOpen}
            isComplete={isComplete}
            onClick={onClick}
        >
            <p>{i18n.t('setup:steps.optimise-deliverability.content')}</p>
            <div>
                <Button
                    className='button-primary button-small'
                    iconRight={<Icons icon='arrowRight' />}
                    onClick={(e) => {
                        e.stopPropagation()
                        onOptimize()
                    }}
                    postHogTag={postHogTag}
                >
                    {i18n.t('setup:steps.optimise-deliverability.button-text')}
                </Button>
            </div>
        </OnboardingStep>
    )
}

DeliverabilityStep.splash = <img src={DeliverabilitySplash} alt={i18n.t('setup:steps.optimise-deliverability.title')} />
